import { useTranslation } from "react-i18next";

import TailsSVG from "../SVGs/TailsSVG";
import NaturalSVG from "../SVGs/NaturalSVG2";
import ExtraAbsorbentSVG from "../SVGs/ExtraAbsorbentSVG2";
import StressFreeMaintenanceSVG from "../SVGs/StressFreeMaintenanceSVG2";

import styles from "./styles.module.scss";

const ExtraInfo = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.extraInfo}>
      <div className={styles.item}>
        <TailsSVG />
        <div className={styles.itemInfoContent}>
          <p>{t("tailsWaggingGuarantee")}</p>
          <p className={styles.fs11}>{t("ifNotHappy")}</p>
        </div>
      </div>
      <div className={styles.item}>
        <NaturalSVG />
        <p>{t("100natural")}</p>
      </div>
      <div className={styles.item}>
        <ExtraAbsorbentSVG />
        <p>{t("extraAbsorbent")}</p>
      </div>
      <div className={styles.item}>
        <StressFreeMaintenanceSVG />
        <p>{t("stressFreeMaintenance")}</p>
      </div>
    </div>
  );
};

export default ExtraInfo;
